/*
  Brand color helpers for the Connect branding preview.

  Mirrors the derivation the API applies when rendering emails
  (api/src/email/color.js) so the swatch preview in Connect matches what the
  pharmacy's customers actually receive.
*/

export const BRAND_DEFAULT_COLOR = '#F47B20';

const HEX_PATTERN = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

export const isValidHexColor = (value) =>
  typeof value === 'string' && HEX_PATTERN.test(value.trim());

const expand = (hex) => {
  const body = hex.replace('#', '');
  return body.length === 3
    ? body
        .split('')
        .map((char) => char + char)
        .join('')
    : body;
};

/** WCAG 2.1 relative luminance. */
const relativeLuminance = (hex) => {
  const body = expand(hex);
  const channels = [0, 2, 4].map((offset) => {
    const srgb = parseInt(body.slice(offset, offset + 2), 16) / 255;
    return srgb <= 0.03928 ? srgb / 12.92 : Math.pow((srgb + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * channels[0] + 0.7152 * channels[1] + 0.0722 * channels[2];
};

const contrastRatio = (foreground, background) => {
  const a = relativeLuminance(foreground);
  const b = relativeLuminance(background);
  return (Math.max(a, b) + 0.05) / (Math.min(a, b) + 0.05);
};

/** Whichever of white or near-black reads better on the given background. */
export const readableTextColor = (background) => {
  if (!isValidHexColor(background)) return '#FFFFFF';
  return contrastRatio('#FFFFFF', background) >= contrastRatio('#1A1A1A', background)
    ? '#FFFFFF'
    : '#1A1A1A';
};



// WEBPACK FOOTER //
// ./src/utils/brandColor.js